import {createHookDefinition} from '../../utils/hooksUtils'
import type {PublishPipelineMessage} from '../distributor/messages'

export const PUBLISH_HOOKS = {
    PUBLISH: {
        STATUS: createHookDefinition<'site_publish_status', PublishPipelineMessage>('site_publish_status')
    }
}
